const {groupByEdition} = require('./editions.cjs')

function groupAssessmentSummary(items = []) {
  return groupByEdition(items).map(edition => {
    const sections = []
    const lookup = new Map()
    for (const item of edition.items) {
      const key = JSON.stringify([item.subject, item.grade])
      let section = lookup.get(key)
      if (!section) {
        section = {subject:item.subject, grade:item.grade, items:[]}
        lookup.set(key, section)
        sections.push(section)
      }
      section.items.push(item)
    }
    return {...edition, sections}
  })
}

module.exports = {groupAssessmentSummary}
